import React from "react";
import PropTypes from "prop-types";
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'


const Steps = ({currentStep, stepSize}) => {
  const stepNumbers = Array.from([...Array(stepSize).keys()], (num) => num + 1);

  const Step = ({stepNumber, currentStep}) => {
    const isActive = stepNumber === currentStep;
    return <li id={"step" + stepNumber} className={isActive ? "is-current" : ""}>{"STEP" + stepNumber}</li>;
  };

  Step.propTypes = {
    stepNumber: PropTypes.number,
    currentStep: PropTypes.number,
  }

  return (
    <ol className="step">
      {stepNumbers.map((stepNumber, i) => <Step key={i} stepNumber={stepNumber} currentStep={currentStep}/>)}
    </ol>
  );
};

Steps.propTypes = {
  currentStep: PropTypes.number,
  stepSize: PropTypes.number,
};

export default Steps;